import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export const SortDropdown = ({ sortBy, setSortBy }) => {
  return (
    <FormControl
      variant="outlined"
      size="small"
      className="my-listings-sort"
      sx={{ minWidth: { xs: "100%", sm: 220 } }}
      fullWidth
    >
      <InputLabel id="sort-by-label">Sort by</InputLabel>
      <Select
        labelId="sort-by-label"
        id="sort-by-select"
        value={sortBy}
        label="Sort by"
        onChange={(e) => {
          setSortBy(e.target.value);
        }}
      >
        <MenuItem value="-total_sales">Total Sales (High - Low)</MenuItem>
        <MenuItem value="total_sales">Total Sales (Low - High)</MenuItem>
        <MenuItem value="-total_sales_this_month">
          Sales This Month (High - Low)
        </MenuItem>
        <MenuItem value="-price">Price (High - Low)</MenuItem>
        <MenuItem value="price">Price (Low - High)</MenuItem>
        <MenuItem value="-total_earned">Total Earned (High - Low)</MenuItem>
        <MenuItem value="-total_earned_this_month">
          Earned This Month (High - Low)
        </MenuItem>
        <MenuItem value="-created_at">Newest</MenuItem>
        <MenuItem value="created_at">Oldest</MenuItem>
        <MenuItem value="-view_count">Views(High - Low)</MenuItem>
         <MenuItem value="view_count">Views(Low - High)</MenuItem>
      </Select>
    </FormControl>
  );
};

